import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://vnwgltngyemkmmuhcuiw.supabase.co";
const supabaseKey =
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZud2dsdG5neWVta21tdWhjdWl3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjIyMjM0NTAsImV4cCI6MjAzNzc5OTQ1MH0.XJdXmGpSOAz4J7zpMy2CjRqbJbtOKF6izVe5tmQULXQ";
export const supabase = createClient(supabaseUrl, supabaseKey);
